import { useEffect, useState } from "react"
import { Input, Button, Table, Space, DatePicker } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable } from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import { SelectStores } from "../../component/common/Selects"
import _ from 'lodash'

const { Column } = Table
const { RangePicker } = DatePicker

type fetchParams = {
    store_id: string | undefined,
    user_name: string | undefined,
    phone: string | undefined,
    item_name: string | undefined,
    date: any
}

type pagination = {
    current: number,
    pageSize: number,
    total: number
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        store_id: undefined,
        user_name: undefined,
        phone: undefined,
        item_name: undefined,
        date: null
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0
    })

    // 列表数据
    const [data, setData] = useState<any>([])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        let iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        if (params.date) {
            params.order_start_date = params.date[0].format('YYYY-MM-DD')
            params.order_end_date = params.date[1].format('YYYY-MM-DD')
            delete params.date
        }

        axiosTable.get('/yuezi_center/order/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    return (<div className="common-page">
        {/* 月子中心 -> 月子项目管理 -> 月子订单管理 */}
        <BreadCrumb position={['月子中心', '月子订单管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores onChange={(value: string) => { handleChange(value, 'store_id') }} value={fetchOtherParams.store_id} />
                </div>

                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="客户姓名" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'user_name') }} value={fetchOtherParams.user_name} />
                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="客户手机号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'phone') }} value={fetchOtherParams.phone} />

                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: '250px' }} placeholder={["签单开始日期", "签单结束日期"]} value={fetchOtherParams.date} onChange={(v: any) => { handleChange(v, 'date') }} />
                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="签单套餐" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'item_name') }} value={fetchOtherParams.item_name} />
            </Space>

            <div style={{ marginTop: 10 }}>
                <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
            </div>
        </div>

        <div className="common-main">
            <Table dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={pagination} onChange={handleTableChange}>
                <Column title="门店名称" dataIndex="store_name" key="store_name" />
                <Column title="客户姓名" dataIndex="user_name" key="user_name" />
                <Column title="客户手机号" dataIndex="phone" key="phone" />
                <Column title="来源渠道" dataIndex="channel_name" key="channel_name" />
                <Column title="签单日期" dataIndex="deal_date" key="deal_date" />
                <Column title="签单套餐" dataIndex="item_name" key="item_name" />
                <Column title="合同金额" dataIndex="agreement_amount" key="agreement_amount" />
                <Column title="已收金额" dataIndex="total_pay_amount" key="total_pay_amount" />
                <Column title="剩余尾款" dataIndex="left_amount" key="left_amount" />
            </Table>
        </div>
    </div >)
}